module.exports = __webpack_public_path__ + "img/20_132.677af993.png";